import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import styles from './Separator.module.scss';
export const GetSeparatorTID = (parentTestId)=>getTestIds(parentTestId);
export function Separator(param) {
    let { skin = 'default', spacing = 'medium', vertical, height, testId } = param;
    const { SeparatorTID } = useMemo(()=>GetSeparatorTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": SeparatorTID.Root(),
        className: cn(vertical ? styles.verticalSeparator : styles.horizontalSeparator, styles["spacing-".concat(spacing)], styles["skin-".concat(skin)]),
        style: {
            blockSize: height
        }
    });
}
